import { FaAnglesLeft } from 'react-icons/fa6';

const QuestionOverview = ({
  questionOverViewOpen,
  setQuestionOverviewOpen,
  questions,
  currentQuestion,
  setCurrentQuestion,
  askedConfirmation
}) => {
  const legendItems = [
    { color: 'bg-blue-500', label: 'Answered' },
    { color: 'bg-red-500', label: 'Marked' },
    { color: 'bg-[#8dc5eb]', label: 'Location' },
    { color: 'bg-red-800', label: 'Marked & answered' }
  ];

  const getQuestionStyle = (question, idx) => {
    if (currentQuestion?.questionIds === question?.questionIds) {
      return 'bg-[#8dc5eb]';
    }
    if (askedConfirmation[idx]) {
      return 'bg-blue-500';
    }
    if (question.bookMarked && question.selectedOption != null) {
      return 'bg-red-800';
    }
    if (question.bookMarked) {
      return 'bg-red-500';
    }
    if (question.selectedOption != null) {
      return 'bg-blue-500';
    }
    return 'bg-[#4d4d4d]';
  };

  const handleQuestionSelect = (question) => {
    setCurrentQuestion(question);
    if (window.innerWidth < 768) {
      setQuestionOverviewOpen(false);
    }
  };

  return (
    <div
      className={`
        fixed top-0 left-0      
        h-screen z-[1000] bg-[#273036] overflow-y-scroll
        transform transition-transform duration-300 ease
        ${questionOverViewOpen ? 'translate-x-0' : '-translate-x-full'}
        w-full md:relative md:border-r md:border-gray-800 md:drop-shadow-xl
        scrollbar-thin scrollbar-track-gray-700 scrollbar-thumb-gray-500
      `}
      style={{
        visibility: questionOverViewOpen ? 'visible' : 'hidden',
      }}
    >
      {/* Mobile Close Button */}
      <div className="md:hidden fixed top-2 right-2 z-[1100]">
        <FaAnglesLeft
          onClick={() => setQuestionOverviewOpen(false)}
          className="text-white text-2xl cursor-pointer"
        />
      </div>

      <div className="w-full min-h-full text-white p-6 space-y-6 mb-[100px]">
        {/* Header Section */}
        <div>
          <h1 className="mt-4 text-2xl font-semibold mb-6">Pvault SAT</h1>
          <div className="grid grid-cols-2 gap-4 text-sm mb-4">
            {legendItems.map(({ color, label }) => (
              <div key={label} className="flex items-center space-x-2">
                <div className={`w-6 h-6 ${color} rounded-sm`} />
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Guidance Text */}
        <div className="space-y-1">
          <p className="text-lg">Answer all questions</p>
        </div>

        {/* Question Grid */}
        <div className="grid gap-2 mt-2 grid-cols-5 md:grid-cols-4 overflow-y-auto">
          {questions.map((question, idx) => (
            <div
              key={`question-${idx}`}
              onClick={() => handleQuestionSelect(question)}
              className={`
                rounded-md h-[45px] flex justify-center items-center cursor-pointer
                ${getQuestionStyle(question, idx)} text-white
              `}
            >
              {idx + 1}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuestionOverview;
